if (typeof IN == "undefined" || !IN) {
	var IN = {};
}

IN.SmsVerificationHelper = Ember.Mixin.create({

	sms_status_message: null,

	checkSMSDeliveryStatus: function(plivo_id, intervalCallback) {

		// privates
		var self = this,
			checkInterval = null,
			intervalCallback = intervalCallback ? intervalCallback : function(){},

			// function that is being called a few times by an interval
			check = function(callback) {

				if(!plivo_id) {

					callback({
						status: 'error',
						message: 'De status van je sms kan helaas niet opgevraagd worden.'
					});

					clearInterval(checkInterval);

					return;
				};

				$.ajax({
					url: '/v1/plivo/sms/status',
					type: 'POST',
					contentType: 'application/json',
					dataType: 'json',
					data: JSON.stringify({
						plivo_id: plivo_id
					}),
					error: function(err) {

						if(checkInterval) {
							clearInterval(checkInterval);
						}

						// this needs to be handled as a 500 error returns...
						callback({
							status: "error",
							message: "xhr_server_error"
						});

					}
				}).done(function(response) {
					callback(response);
				});
			};

		// the return product: a promise. it resolves once the check function returns positive
		// else - e.g an error - it will reject the promise. This interfaces an XOR into the
		// send_sms callback and is downright applicable to multiple sms bases.
		return new Promise(function(resolve, reject) {

			// assumption intervals limit is set to 60 (1 minute)
			// 1 interval == 1 second
			var intervals = 0,
				assumptionIntervals = 60;

			checkInterval = setInterval(function() {

				// evaluate check for sms delivery
				check(function(response) {

					intervalCallback(response);

					if(response.status === 'success') {

						// on success, resolve the promise and clear the interval.
						if(checkInterval) {
							clearInterval(checkInterval);
							resolve(response);
						}

					} else {
						// from the error hook on the ajax call to the server
						// callback will be called with a custom client error.
						// this will be passed into the promise reject hook.

						// also the interval will be cleared as this will not work.
						if(response.message === 'xhr_server_error') {
							if(checkInterval) {
								clearInterval(checkInterval);
								resolve(response.message);
							}
							reject(response);
						}

					}

					// check if intervals equals assumptionable intervals for a
					// custom timeout handle - it will reject the promise as a
					// result.
					if(intervals == assumptionIntervals) {

						// clear the interval in order to wait on clients interaction
						if(checkInterval) {
							clearInterval(checkInterval);
						}

						// reject the promise
						reject({
							status: "error",
							message: "Wij constateren dat het lang duurt voor de sms aankomt. Klik op 'opnieuw proberen' om opnieuw een sms te versturen."
						});

					} else {
						// increment intervals
						intervals++;
					}
				});

			}, 1000)
		});
	}
});

IN.AnalyticsHandler = function() {

    var locationString = IN.App.get('currentPath');

    switch(IN.App.get('currentPath')) {
        case 'login':
            locationString = 'Login overview';
        break;
        case 'cellverification':
            locationString = 'User requested verification via phone';
        break;
        case 'smsverification':
            locationString = 'User requested verification via SMS';
        break;
        case 'lostpasswordsms':
            locationString = 'User attempts to recover password using SMS';
        break;
        case 'lostpasswordcall':
            locationString = 'User attempts to recover password using phone';
        break;
        case 'changepassword':
            locationString = 'User is changing password';
        break;
        case 'inputemail':
            locationString = 'User is sending email for password recovery';
        break;
        case 'detailssentlost':
            locationString = 'User succeeded in password recovery';
        break;
    }
}

IN.App = Ember.Application.create({
	 currentPath: '',
	 googleClientID: '519139390440-kllasp6tj0ppa52fhiftcl2npmlch9i2.apps.googleusercontent.com'
});

IN.App.Router.reopen({
	GA: IN.AnalyticsHandler.on('didTransition')
});

IN.App.Router.map(function () {
	this.route("login", {
		path: "/"
	});
	this.route("cellverification", {
		path: "/call"
	});
	this.route("smsverification", {
		path: "/sms"
	});
	this.route("lostpasswordsms", {
		path: "/lostpassword/sms"
	});
	this.route("lostpasswordcall", {
		path: "/lostpassword/call"
	});
	this.route("changepassword", {
		path: "/lostpassword/change"
	});
	this.route("inputemail", {
		path: "/lostpassword/inputemail"
	});
	this.route("detailssentlost", {
		path: "/lostpassword/detailssentlost"
	});

	this.route("pagenotfound", { path: "*path" });

});

IN.App.PagenotfoundRoute = Em.Route.extend({
	actions: {
		didTransition: function() {
			this.transitionTo("login");
		}
	}
});

IN.App.TokenHelper = {
	set: function(token) {
		Cookies.set('jwt_token', token);
		return token;
	},
	get: function() {
		return Cookies.get('jwt_token');
	},
	flush: function() {
		Cookies.remove('jwt_token', { path: '' });
	}
}
